import React from "react";
import { IconButton } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export default function SidebarCollapseToggle({ collapsed = false, onClick }) {
  const theme = useTheme();

  return (
    <IconButton
      onClick={onClick}
      aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
      aria-expanded={!collapsed}
      size="small"
      sx={{
        position: "absolute",
        top: 66,
        right: -14,
        zIndex: theme.zIndex.drawer + 10,
        width: 28,
        height: 28,
        p: 0,
        bgcolor: "var(--theme-sidebar-surface, #1e293b)",
        color: "var(--theme-sidebar-text-muted, #94a3b8)",
        border: "1px solid var(--theme-sidebar-border, rgba(255, 255, 255, 0.12))",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.25)",
        transition: "background-color 0.18s ease, color 0.18s ease, border-color 0.18s ease",
        "&:hover": {
          bgcolor: "#334155",
          color: "var(--theme-sidebar-text, #f8fafc)",
          borderColor: "rgba(255, 255, 255, 0.18)",
        },
        "&:focus-visible": {
          outline: "2px solid var(--theme-primary, #2563eb)",
          outlineOffset: 2,
        },
      }}
    >
      {collapsed ? (
        <ChevronRightIcon sx={{ fontSize: 18 }} />
      ) : (
        <ChevronLeftIcon sx={{ fontSize: 18 }} />
      )}
    </IconButton>
  );
}
